export default [
  {
    path: "/paises",
    component: () => import("@/views/paises/Listar.vue"),
  },
  {
    path: "/paises/crear",
    component: () => import("@/views/paises/Crear.vue"),
  },
  {
    path: "/paises/editar/:id",
    component: () => import("@/views/paises/Editar.vue"),
  },
];
